import { Stack } from "@mui/material";
import { FMFiltersProps } from "../../types";
import SearchBox from "../../../../core-components/theme/components/Searchbox/Searchbox";
import { Neutrals } from "../../../../core-components/theme/color-palette/colors";

const FMFilters = ({handleSearch, children, stackSxProps={}, searchBoxSxProps={}}: FMFiltersProps) => {
  return (
    <Stack direction="row" sx={{...stackSxProps}} rowGap={6} columnGap={6}>
      <SearchBox
        placeholder="Search Documents"
        sx={{
          height: '52px',
          borderColor: Neutrals[500],
          borderRadius: '4px',
          flex: 1,
          ...searchBoxSxProps
        }}
        onSearch={(value: string) => handleSearch(value)}
        onClear={() => handleSearch('')}
        fullWidth={true}
      />
      {
        children && <>{children}</>
      }
    </Stack>
  )
}

export default FMFilters;